import React from 'react';
import './styles/App.scss';
import {Form, InputGroup} from "react-bootstrap";
import CardService from "./services/CardService";
import ClientService from "./services/ClientService";
import CountryService from "./services/CountryService";
import "react-datepicker/dist/react-datepicker.css";
import ModalInfo from "./components/ModalInfo";
import BannerCardCliente from './components/BannerCardCliente/BannerCardCliente';
import FormExtrangero from './components/Form/FormularioExtrangero';
import FormDataPersonal from './components/Form/FormDataPersonal'

class App extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            cardBalance: 0,
            cardTarifa: '', // General | Personalizada...
            cardClient: '',
            validatedForm: false,
            cardIsValid: false,
            registroCivilDate: '',
            nroCard: '',
            document: '',
            name: '',
            surname: '',
            phone: '',
            email: '',
            birthday: '',
            showFormUser: true,
            listCards: [],
            listCountry: [],
            registerData_K_RC: false,//  Si no consta datos en Kbus y Registro Civil
            isForeign: false,   // Estado para saber si es Extrangero
            isRegistered: false, // Estado para controlar si esta registrado en pasaporte.
            showFormPersonal: false,
        };
    }

    render() {
        {this.findCountry()}
        return (
            <div style={{background: 'url("img/fondo.png") 45% 0% / cover no-repeat'}} className="main-app">
                <div className="d-flex justify-content-between pt-4">
                    <h2 className="title-app font-weight-bold text-white">Registro de <br/> Tarjeta SITU</h2>

                    <div className="upload-container text-warning h4 mt-4">
                        <i>¡A donde sea con mi tarjeta SITU!</i>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-3'>
                            <img className="img-cards" src="img/tarjetas.png" alt="Tarjetas"/>
                        </div>
                        <div className='col-6'>
                            <div className='row mt-8'>
                                <div className='col-md-3'></div>
                                <div className={(this.state.showFormUser) ? 'col-md-6' : 'col-12 col-md-10 offset-md-2'}>
                                    <h3 className="text-warning font-weight-bold mt-6">¿Deseas consultar el saldo de tu tarjeta o personalizarla?</h3>
                                    <Form noValidate validated={this.state.validatedForm} 
                                        // </div>onSubmit={this.handleSubmitUser.bind(this)}
                                    >
                                        <Form.Group controlId="formTelefono">
                                            <InputGroup>
                                                <Form.Control 
                                                    value={this.state.nroCard}
                                                    onChange={this.updateInput.bind(this, 'nroCard')} type="text"
                                                    //onKeyDown={this.findCard.bind(this)}
                                                    onKeyDown={this.onKeyPressed.bind(this)}
                                                    tabIndex = "0"
                                                    required
                                                    pattern="\d{9}|\d{10}|\d{12}"
                                                    className="input-lineal"
                                                    // autoComplete='off'
                                                    placeholder="Cédula ó # de tarjeta" />
                                                <InputGroup.Prepend>
                                                    <button type="button" onClick={this.findCard.bind(this)}><i className="fa fa-search"></i></button>
                                                </InputGroup.Prepend>
                                                <Form.Control.Feedback type="invalid">Ingrese una cédula o tarjeta válida</Form.Control.Feedback>
                                            </InputGroup>
                                            <small className="form-text text-muted">
                                                Ingresa el número de tu tarjeta (010170010883), consulta tu saldo o personalízala rellenando los datos del formulario
                                            </small>
                                        </Form.Group>
                                    </Form>
                                </div>
                                <div className='col-md-3'></div>
                            </div>
                            <div className="row mt-8">
                                <div className={(this.state.showFormUser) ? 'col-md-12' : 'col-12 col-md-10 offset-md-2'}>
                                    { this.state.listCards.length ? 
                                        <div className='col-md-12'>
                                            <div>
                                                <BannerCardCliente datos={this.state.listCards}/>
                                            </div>
                                            <div className="text-center mb-2" style={{marginTop: '1em'}}>
                                                <button className="btn btn-primary" type="button" onClick={this.clearForm.bind(this)}>Limpiar búsqueda</button>
                                            </div>
                                        </div>
                                    : null
                                    }
                                </div>
                            </div>
                            <div className="row mt-8">
                                <div className='col-md-3'></div>
                                <div className={(this.state.showFormUser) ? 'col-md-6' : 'col-12 col-md-10 offset-md-2'}>
                                        <p className="text-secondary mt-4 saldo">
                                            El Saldo a consultar puede tardar hasta 24 horas en actualizarse.
                                        </p>

                                        <p className="text-center">
                                            <ModalInfo/>
                                        </p>
                                        <p className="text-center">
                                            <a href="https://play.google.com/store/apps/details?id=com.kradac.situ"
                                            className="btn btn-primary"
                                            target="_blank"
                                            rel="noreferrer noopener"
                                            >Descargar App SITU</a>
                                        </p>
                                </div>
                                <div className='col-md-3'></div>
                            </div>
                        </div>
                        <div className='col-3'>
                            {this.state.showFormPersonal ? 
                                <FormDataPersonal
                                    setFormPersonalizar = {this.setFormPersonalizar.bind(this)}
                                    showFormUser={this.state.showFormUser}
                                    listaCountry = {this.state.listCountry}
                                    listaCards = {this.state.listCards}
                                />
                                : <FormExtrangero isActive={this.state.isForeign}/>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    setFormPersonalizar() {
        this.setState({
            showFormPersonal: false
        });
    }
    onKeyPressed(event) {
        if(event.key === "Enter") {
            this.findCard();
            event.preventDefault();
            event.stopPropagation();
        }
    }

    handleSubmitUser(event)
    {
        console.log("enviar a crear", this.state, event);
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();

        if (form.checkValidity() === false) {
            this.setState({validatedForm: true});
            return;
        }

        if (!this.state.registroCivilDate) {
            this.warningAlert('Formulario', 'Debes comprobar el número de cédula para continuar');
            return;
        }

        if (!this.state.showFormUser) {
            this.findCard();
            return;
        }

        if (this.state.nroCard.length !== 12 && this.state.nroCard.length !== 10) {
            this.warningAlert('Datos incorrectos', 'Ingrese una cédula o número de tarjeta válidos.');
            this.setState({
                cardIsValid: false,
                validatedForm: false,
            });
        }

        if (this.state.nroCard.length === 12) { // Al buscar tarjeta
            if (!this.state.cardIsValid) {
                this.warningAlert('Tarjeta no válida', 'Antes de continuar, se debe comprobar los datos de la tarjeta.');
                return;
            }
        }


        if (this.state.nroCard.length === 10) { // Al buscar cedula
            if (!this.validateCedula(this.state.nroCard, 'Por favor ingrese una cédula válida')) {
                this.setState({validatedForm: false})
                return;
            }
        }

        if (this.state.showFormUser) {
            if (!this.validateCedula(this.state.document, 'Por favor ingrese una cédula válida')) {
                this.setState({validatedForm: false})
                return;
            }
        }

        this.setState({validatedForm: true});

        this.loadingAlert('Tarjetas SITU', 'Enviando formulario.');

        if (this.compareDates(this.state.registroCivilDate)) {
            this.createCardRecord();
            return;
        }
        this.warningAlert('Fecha de nacimiento incorrecta', 'La fecha de nacimiento no coincide con el de la persona.')
    }


    findCard() {
        // event.preventDefault();
        // event.stopPropagation();
        //if (event.key === "Enter" || event.type === 'click') {
            this.loadingAlert('Consultando');
            if (this.state.nroCard.length === 9 || this.state.nroCard.length === 11 || this.state.nroCard.length === 12) { // Al buscar tarjeta
                CardService.find(this.state.nroCard)
                    .then((response) => {
                        if(response.existe) {
                            this.setState({
                                showFormPersonal: false
                            });
                        }else {
                            this.setState({
                                showFormPersonal: true
                            });
                        }
                        this.setCardData(response);
                        window.Swal.close();
                    })
                    .catch((error) => {
                        this.warningAlert('Ha ocurrido un error.', error.m);
                        this.setState({
                            cardIsValid: false,
                            validatedForm: false,
                            listCards: [],
                            nroCard: '',
                            showFormPersonal: false
                        });
                    });
            return;
            }

            if (this.state.nroCard.length === 10) { // Al buscar cedula
                if (!this.validateCedula(this.state.nroCard, 'Por favor ingrese una cédula válida')) {
                    this.setState({validatedForm: false});
                    return;
                }
                CardService.find(this.state.nroCard)
                    .then((response) => {
                        this.setState({
                            showFormPersonal: false
                        });
                        this.setCardData(response);
                        window.Swal.close();
                    })
                    .catch((error) => {
                        this.warningAlert(error.m, 'UPS! Hubo un problema con la conexión al servidor.');
                        this.setState({
                            listCards: [],
                            nroCard: '',
                            showFormPersonal: false
                        });
                    });
                return;
            }

            this.warningAlert('Datos incorrectos', 'Ingrese una cédula o número de tarjeta válidos.');
            this.setState({
                cardIsValid: false,
                validatedForm: false,
            });
            return;
        //}
    }

    findCountry() {
        setTimeout(function() {
            CountryService.find()
            .then((response) => {
                this.setCountryData(response);
            })
            .catch((error) => {
                //console.log("Ocurrió un error al obtener los países");
            });
        },10000)
    }

    formatDate(date) {
        if (!date) return;

        const year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();

        if (month < 10) {
            month = `0${month}`;
        }
        if (day < 10) {
            day = `0${day}`;
        }
        return `${year}-${month}-${day}`;
    }

    dateRegistroCivil(date) {
        if (!date) return;

        const year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();

        if (month < 10) {
            month = `0${month}`;
        }
        if (day < 10) {
            day = `0${day}`;
        }
        return `${day}/${month}/${year}`;
    }

    validateCedula(cad, msg) {
        let total = 0;
        let longitud = cad.length;
        let longcheck = longitud - 1;

        if (cad !== "" && longitud === 10){
            for(let i = 0; i < longcheck; i++){
                if (i%2 === 0) {
                    var aux = cad.charAt(i) * 2;
                    if (aux > 9) aux -= 9;
                    total += aux;
                } else {
                    total += parseInt(cad.charAt(i)); // parseInt o concatenará en lugar de sumar
                }
            }

            total = total % 10 ? 10 - total % 10 : 0;

            const isValid = cad.charAt(longitud-1) == total;
            if(!isValid) {
                this.warningAlert('Campo no válido', msg);
            }
            return isValid;
        }
        this.warningAlert('Campo no válido', msg);
        return false;
    }

    clearForm() {
        this.setState({
            cardBalance: 0,
            cardTarifa: '',
            cardClient: '',
            validatedForm: false,
            cardIsValid: false,
            registroCivilDate: '',
            nroCard: '',
            document: '',
            name: '',
            surname: '',
            phone: '',
            email: '',
            birthday: '',
            showFormUser: true,
            listCards: [],
            listCountry: [],
            registerData_K_RC: false,//  Si no consta datos en Kbus y Registro Civil
            isForeign: false,   // Estado para saber si es Extrangero
            isRegistered: false, // Estado para controlar si esta registrado en pasaporte.
            showFormPersonal: false,
            validateCarga: false,
        });
    }
    updateInput(name, event) {
        const state = this.state;
        state[name] = event.target.value;
        this.setState(state);

        // Si se modifica la tarjeta y ya ha sido validada
        if (name === 'nroCard' && this.state.cardIsValid) {
            this.setState({
                cardIsValid: false
            });
        }
    }

    compareDates(stringDate) {
        console.log(stringDate.trim(), this.dateRegistroCivil(this.state.birthday).trim());
        return stringDate === this.dateRegistroCivil(this.state.birthday);
    }
    createCardRecord() {
        ClientService.create({
            tarjeta: this.state.nroCard,
            cedula: this.state.document,
            nombre: this.state.name,
            apellido: this.state.surname,
            correo: this.state.email,
            fechaNacimiento: this.formatDate(this.state.birthday),
        }).then((response) => {
            this.successAlert('Formulario enviado', response.m).then(() => {
                this.clearForm();
            });
        }).catch((error) => {
            this.warningAlert('Ha ocurrido un error.', error.m);
        });
    }


    warningAlert(title, description) {
        return window.Swal.fire(title, description, 'warning');
    }

    successAlert(title, description) {
        return window.Swal.fire(title, description, 'success');
    }

    loadingAlert(title, content) {
        return window.Swal.fire({
            title,
            html: content,
            timerProgressBar: true,
            onBeforeOpen: () => {
                window.Swal.showLoading()
            },
            allowOutsideClick: () => !window.Swal.isLoading(),
        })
    }

    setCountryData(response) {
        const datosPais = response.data;
        if (typeof datosPais !== 'object') {
            console.log("Ocurrió un error al traer datos de los países");
            return;
        }
        const lista = [];
        for (let index = 0; index < datosPais.length; index++) {
            lista.push(datosPais[index]);
        }
        this.setState({
            listCountry: lista
        });
    }

    setCardData(response) {
        const datosTarjeta = response.datosTarjeta;
        if (typeof datosTarjeta !== 'object') {
            this.warningAlert('Ha ocurrido un error', 'No se ha podido obtener los datos de la tarjeta');
            return;
        }
        const lista = [];
        for (let index = 0; index < datosTarjeta.length; index++) {
            lista.push(datosTarjeta[index]);
            lista[index].id = index + 1;
        }
        this.setState({
            listCards: lista
        });
            
    }

    // Funcion para separar nombres y apellidos
    formatName(name) {
        const names = name.split(' ');

        if (!names.length) {
            return;
        }

        if (names.length === 1) {
            this.setState({
                surname: name,
            });
            return;
        }

        if (names.length === 2) {
            this.setState({
                surname: names[0],
                name: names[1],
            });
            return;
        }

        if (names.length === 3) {
            this.setState({
                surname: `${names[0]} ${names[1]}`,
                name: names[2],
            });
            return;
        }

        if (names.length === 4) {
            this.setState({
                surname: `${names[0]} ${names[1]}`,
                name: `${names[2]} ${names[3]}`,
            });
        }
    }
}

export default App;
